import Repository from "../../repository";

export default {
    Get: (payload) => Repository.post(`/api/AdjustDebits/Get`, payload),
    GetById: (payload) => Repository.post(`/api/AdjustDebits/GetById`, payload),
    Add: (payload) => Repository.post(`/api/AdjustDebits/Add`, payload),
    Edit: (payload) => Repository.post(`/api/AdjustDebits/Edit`, payload),
    Delete: (payload) => Repository.post(`/api/AdjustDebits/Delete`, payload),
}
